export const MAPPING_NOT_MAPPED_VALUE = '__not_mapped__';
